import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';

const TEST_MODE = false;

const EMAILJS_SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const EMAILJS_PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const CONTACT_DETAILS = [
  { icon: '📍', label: 'Dirección', value: 'Tegucigalpa, Honduras' },
  { icon: '📞', label: 'Teléfono', value: '+504 9632-3457', href: 'https://wa.me/50496323457' },
  { icon: '✉️', label: 'Email', value: 'GerenciaConsuprog@consuprog.com' },
  { icon: '🕐', label: 'Horario', value: 'Lun–Vie: 7am – 5pm\nSab: 7am – 12m' },
];

const Contact = () => {
  const formRef = useRef(null);
  const [form, setForm] = useState({
    nombre: '',
    empresa: '',
    telefono: '',
    email: '',
    tipo: '',
    mensaje: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);

    if (TEST_MODE) {
      // Simula 1.5s de carga y muestra éxito
      console.log('📧 [TEST MODE] Datos del formulario:', {
        nombre:   form.nombre,
        empresa:  form.empresa,
        telefono: form.telefono,
        email:    form.email,
        tipo:     form.tipo,
        mensaje:  form.mensaje,
      });
      setTimeout(() => {
        setLoading(false);
        setSubmitted(true);
      }, 1500);
      return;
    }

    emailjs
      .send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
        from_name:  form.nombre,
        from_email: form.email,
        reply_to:   form.email,
        empresa:    form.empresa,
        telefono:   form.telefono,
        tipo:       form.tipo,
        mensaje:    form.mensaje,
      }, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setLoading(false);
        setSubmitted(true);
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact__grid">
          {/* Info */}
          <div className="contact__info">
            <h2 className="contact__heading">
              Su proyecto
              <em>empieza aquí.</em>
            </h2>
            <p className="contact__tagline">
              Contáctenos para discutir su proyecto. Ofrecemos evaluación
              inicial gratuita y propuesta técnica sin compromiso.
            </p>
            <div className="contact__details">
              {CONTACT_DETAILS.map((d) => (
                <div
                  key={d.label}
                  className={`contact__detail ${d.label === 'Horario' ? 'contact__detail--multiline' : ''}`}
                >
                  <div className="contact__detail-icon">{d.icon}</div>
                  <div className="contact__detail-content">
                    <span className="contact__detail-label">{d.label}</span>
                    {d.href ? (
                      <a href={d.href} target="_blank" rel="noopener noreferrer" className="contact__detail-value contact__detail-link">{d.value}</a>
                    ) : (
                      <span className="contact__detail-value">{d.value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form */}
          <div className="contact__form-wrap">
            {submitted ? (
              <div className="form-success">
                <span className="form-success__icon">✅</span>
                <h3 className="form-success__title">¡Mensaje recibido!</h3>
                <p className="form-success__text">
                  Nos pondremos en contacto con usted en menos de 24 horas
                  hábiles para discutir su proyecto.
                </p>
              </div>
            ) : (
              <form ref={formRef} className="contact__form" onSubmit={handleSubmit} noValidate>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label" htmlFor="nombre">Nombre completo</label>
                    <input
                      id="nombre"
                      name="nombre"
                      type="text"
                      className="form-input"
                      placeholder="Juan Pérez"
                      value={form.nombre}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="empresa">Empresa</label>
                    <input
                      id="empresa"
                      name="empresa"
                      type="text"
                      className="form-input"
                      placeholder="Opcional"
                      value={form.empresa}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label" htmlFor="telefono">Teléfono</label>
                    <input
                      id="telefono"
                      name="telefono"
                      type="tel"
                      className="form-input"
                      placeholder="+504 0000-0000"
                      value={form.telefono}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="email">Correo electrónico</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="form-input"
                      placeholder="correo@empresa.com"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="tipo">Tipo de proyecto</label>
                  <select
                    id="tipo"
                    name="tipo"
                    className="form-select"
                    value={form.tipo}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>Seleccionar tipo...</option>
                    <option value="residencial">Residencial</option>
                    <option value="comercial">Comercial</option>
                    <option value="infraestructura">Infraestructura</option>
                    <option value="institucional">Institucional</option>
                    <option value="urbanismo">Urbanismo</option>
                    <option value="otro">Otro</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="mensaje">Descripción del proyecto</label>
                  <textarea
                    id="mensaje"
                    name="mensaje"
                    className="form-textarea"
                    placeholder="Cuéntenos brevemente sobre su proyecto..."
                    value={form.mensaje}
                    onChange={handleChange}
                    required
                  />
                </div>

                {error && (
                  <p className="form-error">
                    Ocurrió un error al enviar. Por favor intente de nuevo o contáctenos directamente.
                  </p>
                )}

                <button
                  type="submit"
                  className="form-submit"
                  disabled={loading}
                >
                  {loading ? 'Enviando...' : 'Enviar consulta'}
                  {!loading && (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
